import { combineReducers } from 'redux';
import { LOGIN, AUTHENTICATED, RESET_PASSWORD, CONTINUE_AS_GUEST} from './LoginActions';
import { LOGOUT} from './LogoutActions';

import { Map } from 'immutable';
import { isUndefinedOrNull } from '../../lib/Utils';


let user_status = localStorage.getItem('user_status');
if( isUndefinedOrNull(user_status)){
  user_status = false;
}else{
  user_status = (user_status === 'true');  
}


let defaultState = new Map({
  isFetching: false,
  isAuthenticated: user_status,
  error: false
});

function login(state = defaultState, action) {
  switch (action.type) {
    case CONTINUE_AS_GUEST:
    return Map({
      isFetching: false,
      isAuthenticated: true,
      error: false    
    });
    case LOGIN.REQUEST:
      return Map({
        isFetching: true,
        isAuthenticated: state.get("isAuthenticated"),
        error: false,
        email: action.email
      });
    case LOGIN.SUCCESS:
      return Map({
        isFetching: false,
        isAuthenticated: true,
        error: false,
        email: state.email
      });
    case LOGIN.FAILURE:
      return Map({
        isFetching: false,
        isAuthenticated: false,
        error: action.error,
        email: state.email
      });
    case LOGOUT.SUCCESS:   
      return  Map({
        isFetching: false,
        isAuthenticated: false,
        error: false
      });
    case LOGOUT.FAILURE:      
      return Map({
        isFetching: false,
        isAuthenticated: state.get("isAuthenticated"),
        error: action.error,
        email: state.email
      });
    case LOGOUT.REQUEST:
      return Map({
        isFetching: true,
        isAuthenticated: state.get("isAuthenticated"),
        error: false,
        email: state.email
      });
    case AUTHENTICATED.REQUEST:
      return Map({
        isFetching: true,
        isAuthenticated: state.get("isAuthenticated"),
        error: false,
        email: state.email
      });
    case AUTHENTICATED.SUCCESS:
      return Map({
        isFetching: false,
        isAuthenticated: true,
        error: false,
        email: state.email
      });
    case AUTHENTICATED.FAILURE:
      return Map({
        isFetching: false,
        isAuthenticated: false, //state.get("isAuthenticated"),
        error: action.error,
        email: state.email
      });
    default:
      return state;
  }
}

function passwordReset (state = new Map({
  isFetching: false,  
  data: false,
  error: false
}), action){

  switch(action.type){
    case RESET_PASSWORD.REQUEST:
    return Map({
      isFetching: true,
      data: false,
      error: false
    });    
    case RESET_PASSWORD.SUCCESS:
    return Map({
      isFetching: false,
      data: true,
      error: false
    });
    case RESET_PASSWORD.FAILURE:
    return Map({
      isFetching: false,
      data: true,
      error: action.error
    });
    default:
      return state;
  }
}

const authReducer = combineReducers({ login, passwordReset});

export default authReducer;


// WEBPACK FOOTER //
// ./src/containers/Authentication/AuthenticationReducer.js